module.exports = __webpack_public_path__ + "media/female.24f0d0b9.wav";